import { StaticImage } from 'gatsby-plugin-image';
import { Link, useIntl } from 'gatsby-plugin-intl';
import React from 'react';
export default function Footer() {
  const intl = useIntl();
  const isEnglishLocale = intl.locale === 'en';
  return (
    <div>
      <footer>
        <div className='footer-top'>
          <div className='container'>
            <div className='row f-tp-row'>
              <div className='col-md-6'>
                <div className='footer-logo-sec'>
                  <div className='footer-brand'>
                    <Link to='/'>
                      <StaticImage
                        src='../images/ekso-btm-logo.png'
                        alt='Ekso logo'
                      />
                    </Link>
                  </div>
                  <div className='f-address-sec'>
                    <div className='title-18'>Ekso Bionics</div>

                    {isEnglishLocale ? (
                      <address className='mb-4'>
                        Ph: <a href='tel:(510) 984-1761'>(510) 984-1761</a>{' '}
                        <br />
                        Contact Us:{' '}
                        <a href='mailto:hello@eksobionics.com'>
                          hello@eksobionics.com
                        </a>{' '}
                        <br />
                        101 Glacier Point, Suite A, San Rafael, CA 94901, USA
                      </address>
                    ) : (
                      <address className='mb-4'>
                        Ekso Bionics Europe GmbH
                        <br />
                        Friesenweg 20
                        <br />
                        22763 Hamburg
                        <br />
                        Tel.:{' '}
                        <a href='tel:+49 (0) 40 800 4049 0'>
                          +49 (0) 40 800 4049 0
                        </a>
                        <br />
                        E-Mail:{' '}
                        <a href='mailto:enquiries@eksobionics.com'>
                          enquiries@eksobionics.com
                        </a>
                      </address>
                    )}
                  </div>
                </div>
              </div>

              <div className='col-md-6'>
                {isEnglishLocale && (
                  <div className='footer-customer'>
                    <div>
                      <div className='title-18'>Customer Support</div>
                      <address>
                        EksoNR &amp; Ekso EVO:&nbsp;
                        <a
                          className='c-link'
                          href='mailto:techsupport@eksobionics.com'
                        >
                          techsupport@eksobionics.com
                        </a>
                        <br />
                        Ekso Indego:&nbsp;
                        <a
                          className='c-link'
                          href='mailto:support.indego@eksobionics.com'
                        >
                          support.indego@eksobionics.com
                        </a>
                      </address>
                    </div>
                  </div>
                )}

                <div className='footer-social-media'>
                  <ul className='f-social-media'>
                    {isEnglishLocale ? (
                      <li>
                        <a
                          href='https://www.facebook.com/EksoBionics/?utm_source=web&utm_medium=footer&utm_campaign=so'
                          target='_blank'
                        >
                          <StaticImage src='../images/fb.svg' alt='facebook' />{' '}
                        </a>
                      </li>
                    ) : (
                      <li>
                        <a
                          href='https://www.facebook.com/EksoBionicsDeutsch?utm_source=web&utm_medium=footer&utm_campaign=so'
                          target='_blank'
                        >
                          <StaticImage src='../images/fb.svg' alt='facebook' />{' '}
                        </a>
                      </li>
                    )}

                    <li>
                      <a
                        href='https://twitter.com/EksoBionics?utm_source=web&utm_medium=footer&utm_campaign=so'
                        target='_blank'
                      >
                        <StaticImage src='../images/tw-2.svg' alt='twitter' />{' '}
                      </a>
                    </li>
                    <li>
                      <a
                        href='https://www.youtube.com/EksoBionics?utm_source=web&utm_medium=footer&utm_campaign=so'
                        target='_blank'
                      >
                        <StaticImage src='../images/yt.svg' alt='youtube' />{' '}
                      </a>
                    </li>
                    {isEnglishLocale ? (
                      <li>
                        <a
                          href='https://www.instagram.com/eksobionics/?utm_source=web&utm_medium=footer&utm_campaign=so'
                          target='_blank'
                        >
                          <StaticImage
                            src='../images/ins.svg'
                            alt='instagram'
                          />{' '}
                        </a>
                      </li>
                    ) : (
                      <li>
                        <a
                          href='https://www.instagram.com/eksobionics.de/?utm_source=web&utm_medium=footer&utm_campaign=so'
                          target='_blank'
                        >
                          <StaticImage
                            src='../images/ins.svg'
                            alt='instagram'
                          />{' '}
                        </a>
                      </li>
                    )}

                    <li>
                      <a
                        href='https://www.linkedin.com/company/eksobionics/?utm_source=web&utm_medium=footer&utm_campaign=so'
                        target='_blank'
                      >
                        <StaticImage src='../images/in.svg' alt='linkedin' />{' '}
                      </a>
                    </li>
                    <li>
                      <a
                        href='https://www.tiktok.com/@eksobionics'
                        target='_blank'
                      >
                        <StaticImage
                          src='../images/tiktok-icon.svg'
                          alt='Tiktok'
                        />{' '}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className='row'>
              <div className='col-md-1'></div>
              <div className='col-md-11'>
                <div className='row f-bottom-row'>
                  <div className='col-md-3 f-menu-col animate'>
                    <div className='footer-title'>
                      {intl.formatMessage({ id: 'solutions' })}
                    </div>
                    <ul>
                      <li>
                        <Link to='/eksohealth/'>EksoHealth</Link>
                      </li>
                      <li>
                        <Link to='/eksonr/'>EksoNR</Link>
                      </li>
                      <li>
                        <Link to='/ekso-indego-therapy/'>
                          Ekso Indego Therapy
                        </Link>
                      </li>
                      <li>
                        <Link to='/ekso-indego-personal/'>
                          Ekso Indego Personal
                        </Link>
                      </li>
                      <li>
                        <Link to='/eksoworks/'>EksoWorks</Link>
                      </li>
                      <li>
                        <Link to='/ekso-evo/'>Ekso EVO</Link>
                      </li>
                      <li>
                        <Link to='/past-products/'>
                          {intl.formatMessage({ id: 'past_products' })}
                        </Link>
                      </li>
                    </ul>
                  </div>
                  <div className='col-md-3 f-menu-col animate'>
                    <div className='footer-title'>
                      {intl.formatMessage({ id: 'company' })}
                    </div>
                    <ul>
                      <li>
                        <Link to='/about-us/'>
                          {intl.formatMessage({ id: 'our_company' })}
                        </Link>
                      </li>
                      <li>
                        <Link to='/blog/'>Ekso Blog</Link>
                      </li>
                      <li>
                        <Link to='/news-and-events/'>
                          {intl.formatMessage({ id: 'news_events' })}
                        </Link>
                      </li>
                      <li>
                        <Link to='/careers/'>
                          {intl.formatMessage({ id: 'careers' })}
                        </Link>
                      </li>
                      <li>
                        <Link to='/distributors/'>
                          {intl.formatMessage({ id: 'distributors' })}
                        </Link>
                      </li>
                      <li>
                        <a href='https://ir.eksobionics.com/' target='_blank'>
                          {intl.formatMessage({ id: 'investor_info' })}
                        </a>
                      </li>
                      <li>
                        <a href='https://shop.eksobionics.com/' target='_blank'>
                          Shop
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div className='col-md-3 f-menu-col'>
                    <div className='footer-title'>
                      {intl.formatMessage({ id: 'resources' })}
                    </div>
                    <ul>
                      <li>
                        <Link to='/customer-stories/'>
                          {intl.formatMessage({ id: 'customer_stories' })}
                        </Link>
                      </li>
                      <li>
                        <Link to='/webinars/'>
                          {intl.formatMessage({ id: 'webinars' })}
                        </Link>
                      </li>
                      {isEnglishLocale && (
                        <li>
                          <Link to='/roi-calculator/'>
                            {intl.formatMessage({ id: 'return_on_investment' })}
                          </Link>
                        </li>
                      )}
                      <li>
                        <Link to='/research/'>
                          {intl.formatMessage({ id: 'research' })}
                        </Link>
                      </li>
                      <li>
                        <Link to='/faq/'>FAQ</Link>
                      </li>
                      <li>
                        <Link to='/training/'>
                          {intl.formatMessage({ id: 'training' })}
                        </Link>
                      </li>
                      {/*<li><Link to="/current-customers-distributors/">{intl.formatMessage({ id: "customers_distributors" })}</Link></li> */}
                      <li>
                        <a
                          href='https://pulse.eksobionics.com/'
                          target='_blank'
                        >
                          EksoPulse Login
                        </a>
                      </li>
                      <li>
                        <Link to='/centers'>
                          {intl.formatMessage({ id: 'find_a_center' })}
                        </Link>
                      </li>
                      <li>
                        <Link to='/centers-of-excellence'>
                          {intl.formatMessage({ id: 'centers_of_excellence' })}
                        </Link>
                      </li>
                    </ul>
                  </div>
                  <div className='col-md-3 f-menu-col animate'>
                    <div className='footer-title'>
                      {intl.formatMessage({ id: 'legal' })}
                    </div>
                    <ul>
                      <li>
                        <Link to='/terms-of-use/'>
                          {intl.formatMessage({ id: 'terms_of_use' })}
                        </Link>
                      </li>
                      {isEnglishLocale ? (
                      <span>
                        
                      </span>
                    ) : (
                      <li>
  <Link to='/impressum/'>
  Impressum
  </Link>
</li>
                    )}
                    <li>
                        <Link to='/privacy-policy/'>
                          {intl.formatMessage({ id: 'privacy_policy' })}
                        </Link>
                      </li>
                      <li>
                        <Link to='/cookie-declaration/'>
                          {intl.formatMessage({ id: 'cookie_declaration' })}
                        </Link>
                      </li>
                      <li>
                        <Link to='/accessibility-statement/'>
                          {intl.formatMessage({
                            id: 'accessibility_statement',
                          })}
                        </Link>
                      </li>
                      <li>
                        <Link to='/patents/'>
                          {intl.formatMessage({ id: 'patents' })}
                        </Link>
                      </li>
                      <li>
                        <Link to='/indications-for-use/'>
                          {intl.formatMessage({ id: 'indications_for_use' })}
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='footer-bottom animate'>
          <div className='container'>
            <div className='row'>
              <div className='col-md-12'>
                <p>Copyright 2024 Ekso Bionics</p>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
